<template>
  <b-field>
    <b-select rounded :value="value" @input="e => $emit('input', e)">
      <option value="">All device types</option>
      <option value="mobile">Mobile</option>
      <option value="desktop">Desktop</option>
    </b-select>
  </b-field>
</template>

<script>
export default {
  emits: ['input'],
  props: {
    value: String
  }
}
</script>